import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const BoltMotionFilledIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path
        fillRule="evenodd"
        d="M16.0504 11.3028L17.968 3H16.7236L7.31924 13.6896H13.9696L12.052 21.9924H13.2964L22.6804 11.3028H16.0504ZM5.4 12.167H0V13.727H5.4V12.167ZM2.4 8.56699L7.8 8.56699V10.127L2.4 10.127V8.56699ZM7.8 15.767H2.4V17.327L7.8 17.327V15.767Z"
      />
    </SvgIcon>
  );
});
